import {PaginaLogada} from "../../componentes";
import React, {useEffect, useState} from "react";
import {exibirMensagemSucesso, HttpVerbo, xfetch} from "../../util";
import logoBB from "../../img/png/logo_bb_md.png";
import logoBanese from "../../img/png/logo_banese_md.png";
import logoSidebar from "../../img/png/logo_sidebar.png";
import CardPadrao from "../../componentes/card/card-padrao";
import {Avatar, Grid, Group, Table, TextInput} from "@mantine/core";
import {COL_RESP_2, COL_RESP_6} from "../../config/constantes/constantes-mantine";
import {Conta} from "../../tipos/conta";
import {BotaoSalvar} from "../../componentes/botao/botao-mantine";

function getLogo(banco: string) {
  if (banco === "BANCO DO BRASIL") return logoBB;
  if (banco === "BANESE") return logoBanese;
  return logoSidebar
}

export default function NovaConta() {

  const [isCarregando, setIsCarregando] = useState(false)
  const [contas, setContas] = useState(new Array<Conta>())
  const [conta, setConta] = useState(new Conta());

  function buscarContas() {
    setIsCarregando(true)
    xfetch('/conta', {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => setContas(dados))
      .finally(() => setIsCarregando(false))

  }

  useEffect(() => {
    buscarContas()
  }, [])

  function enviar() {
    setIsCarregando(true)
    xfetch('/conta', conta, HttpVerbo.POST)
      .then(res => res.json())
      .then(() => {
        setConta({conta: '', tipo: '', agencia: '', banco: ''})
        exibirMensagemSucesso('Conta cadastrada com sucesso')
        buscarContas()
      })
      .finally(() => setIsCarregando(false))
  }

  return (
    <PaginaLogada titulo="Nova Conta" isCarregando={isCarregando}>
      <CardPadrao titulo={"Cadastrar Conta"}>
        <Grid>
          <Grid.Col span={COL_RESP_6}>
            <TextInput
              label={"Banco"}
              value={conta.banco}
              onChange={(e) => setConta({...conta, banco: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_2}>
            <TextInput
              label={"Agência"}
              value={conta.agencia}
              onChange={(e) => setConta({...conta, agencia: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_2}>
            <TextInput
              label={"Conta"}
              value={conta.conta}
              onChange={(e) => setConta({...conta, conta: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_2} style={{alignSelf: "flex-end"}}>
            <BotaoSalvar onClick={enviar}/>
          </Grid.Col>
        </Grid>
      </CardPadrao>
      <CardPadrao titulo="Contas cadastradas" mt={50}>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Banco</Table.Th>
              <Table.Th>Agencia</Table.Th>
              <Table.Th>Conta</Table.Th>
              <Table.Th>Tipo</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Thead>
            {contas.map((c, k) => {
              return (
                <Table.Tr key={k}>
                  <Table.Td>
                    <Group>
                      <Avatar src={getLogo(c.banco)} alt="it's me"/>
                      {c.banco}

                    </Group>
                  </Table.Td>
                  <Table.Td>{c.agencia}</Table.Td>
                  <Table.Td>{c.conta}</Table.Td>
                  <Table.Td>{c.tipo}</Table.Td>
                </Table.Tr>
              )
            })}
          </Table.Thead>
        </Table>
      </CardPadrao>
    </PaginaLogada>
  );
}